import { Component, OnInit, AfterViewInit } from '@angular/core';
import { getItemDetailData, putNewItemPV, getFileData } from './item-detail.service';
import { ItemDetailModel, StoreInfo, Store } from './item-detail.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-item-detail',
  templateUrl: './item-detail.component.html',
  styleUrls: ['./item-detail.component.css'],
})
export class ItemDetailComponent implements OnInit, AfterViewInit {
  model = new ItemDetailModel();

  storeInfo: StoreInfo;
  stores: Array<Store>;
  // storeInfoList: Array<StoreInfo>;
  storeInfoList: Array<StoreInfo> = [
    { area: 'a', stores: [] },
    { area: 'a', stores: [] },
  ];

  isDataLoaded = false;

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  buyerRecommendUrl = 'https://dev-ain-mobile-app-new-item.s3-ap-northeast-1.amazonaws.com/uyerRecommendFile_商品テスト_1577345454343.html';

  itemDiscriptionBody: SafeHtml;
  priceDiscriptionBody: SafeHtml;
  buyerCommentBody: SafeHtml;

  private queryParams: any;
  private itemId: Number;
  private clientId: String;

  storeInfoVisible = true;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this._activatedRoute.queryParams.subscribe(params => {
      this.queryParams = params;
      this.itemId = Number(this.queryParams.itemId);
      this.clientId = this.queryParams.clientId;
    });

    const requestPv = {
      item_id: this.itemId,
      mode: 'sp',
    };
    putNewItemPV(requestPv);

    const request = {
      itemId: this.itemId,
      clientId: this.clientId,
    };
    getItemDetailData(request).then(itemData => {
      const { result } = itemData;
      console.log(result);

      const imageList = new Array<string>();
      if (result.image1) {
        imageList.push(result.image1);
      }
      if (result.image2) {
        imageList.push(result.image2);
      }
      if (result.image3) {
        imageList.push(result.image3);
      }
      if (result.image4) {
        imageList.push(result.image4);
      }
      if (result.image5) {
        imageList.push(result.image5);
      }
      if (result.image6) {
        imageList.push(result.image6);
      }

      this.storeInfoList = new Array<StoreInfo>();
      Object.keys(result.storeMap).forEach(key => {
        this.stores = new Array<Store>();
        result.storeMap[key].forEach(storeData => {
          const store: Store = {
            name: storeData.storeName,
            internalStoreCode: storeData.internalStoreCode,
            storeId: storeData.storeId,
            deepLinkUrl: `ainztulpeapp://storedetail/${storeData.storeId}`,
          };
          this.stores.push(store);
        });
        const storeInfo: StoreInfo = {
          area: key,
          stores: this.stores,
        };
        this.storeInfoList.push(storeInfo);
      });
      this.storeInfoVisible = Object.keys(this.storeInfoList).length ? true : false;
      console.log(this.storeInfoList);

      this.model = {
        itemId: result.itemId,
        clientId: result.clientId,
        title: result.title,
        categoryId1: result.categoryId1,
        categoryId2: result.categoryId2,
        releaseDate: result.releaseDate,
        imageList,
        makerSite: result.makerSite,
        clientFileName: result.clientFileName,
        maker: result.maker,
        brand: result.brand,
        storeList: result.storeList,
        priceFileName: result.priceFileName,
        buyerRecommendFlag: result.buyerRecommendFlag,
        buyerRecommendFileName: result.buyerRecommendFileName,
        publishDate: result.publishDate,
      };
      console.log(this.model);

      // S3からファイル情報を取得する
      if (this.model.clientFileName) {
        getFileData(this.model.clientFileName).then(data => {
          this.itemDiscriptionBody = this._sanitizer.bypassSecurityTrustHtml(data);
        });
      }
      if (this.model.priceFileName) {
        getFileData(this.model.priceFileName).then(data => {
          this.priceDiscriptionBody = this._sanitizer.bypassSecurityTrustHtml(data);
        });
      }
      if (this.model.buyerRecommendFileName) {
        getFileData(this.model.buyerRecommendFileName).then(data => {
          this.buyerCommentBody = this._sanitizer.bypassSecurityTrustHtml(data);
        });
      }
      this.isDataLoaded = true;
    });
  }

  ngAfterViewInit() {
    const script = document.createElement('script'); // scriptタグを作ります
    script.async = true;
    script.setAttribute('src', 'https://d.line-scdn.net/r/web/social-plugin/js/thirdparty/loader.min.js');
    script.setAttribute('defer', 'defer');

    const div = document.getElementById('store-title'); // ボタンを置きたい場所の手前の要素を取得
    div.parentNode.insertBefore(script, div.nextSibling); // scriptタグを追加してJSを実行し、aタグをボタンに変身させる
  }

  openAppStoreDetail = url => {
    window.location.href = url;
  };

  openMakerSite = url => {
    window.location.href = url;
  };
}
